import { StandardSpriteMaterial } from '../material/sprite_std.js';
import { BaseSprite } from './basesprite.js';

/**
 * 3D Sprite node
 * @public
 */ class Sprite extends BaseSprite {
    constructor(scene, material){
        super(scene);
        this.material = material ?? new StandardSpriteMaterial();
    }
    isSprite() {
        return true;
    }
}

export { Sprite };
//# sourceMappingURL=sprite.js.map
